module.exports = __webpack_public_path__ + "media/images/metronic/syncfusion-icons-white-ec07f3b496eb7ca3f6940186afbe3941.png";